import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ManagerRouteModule } from "./manager-route.module";
import { DashboardComponent } from "./dashboard/dashboard.component";
import { SharedModule } from "../shared/shared.module";
import { PotralConfigurationComponent } from "./potral-configuration/potral-configuration.component";
import { LanguageListComponent } from "./language-list/language-list.component";
import { FormsModule } from "@angular/forms";
import { PortalLanguageComponent } from "./portal-language/portal-language.component";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { ReportsModule } from "../reports/reports.module";
import { BsDatepickerModule } from "ngx-bootstrap/datepicker";
import { CandidateStatusComponent } from "./dashboard/candidate-status/candidate-status.component";
import { PaymentStatusComponent } from "./dashboard/payment-status/payment-status.component";
import { ListDataComponent } from "./dashboard/list-data/list-data.component";
import { WidgetComponent } from "./dashboard/widget/widget.component";
import { UsersComponent } from "./users/users.component";
import { UsersListComponent } from "./users-list/users-list.component";
import { DefineQuestionTypeComponent } from "./define-question-type/define-question-type.component";
import { UploadExamCenterComponent } from "./upload-exam-center/upload-exam-center.component";
import { PushParentQuestionBankListComponent } from "../manager/push-parent-question-bank-list/push-parent-question-bank-list.component";
import { PushParentQuestionBankComponent } from "../manager/push-parent-question-bank/push-parent-question-bank.component";
import { ConstantConfigurationComponent } from "../manager/constant-configuration/constant-configuration.component";
import { UploadCSRCComponent } from "../manager/csrc/upload-csrc/upload-csrc.component";
import { UploadTestTimingComponent } from "../manager/upload-test-timing/upload-test-timing.component";
import { AppHeaderComponent } from "../manager/app-header/app-header.component";
import { CSRCListComponent } from "../manager/csrc/csrc.component";
import { SectionStatusComponent } from "./dashboard/section-status/section-status.component";
import { TopicStatusComponent } from "./dashboard/topic-status/topic-status.component";
import { TestStatusComponent } from "./dashboard/test-status/test-status.component";
import { JobsComponent } from "./jobs/jobs.component";
import { CandidateListComponent } from "./candidate-list/candidate-list.component";
import { UploadTestCenterUserComponent } from "./upload-test-center-user/upload-test-center-user.component";
import { UploadTestCenterUserListComponent } from "../manager/upload-test-center-user/upload-test-center-user-list/upload-test-center-user-list.component";
import { CsrcDetailsComponent } from "../manager/csrc/csrc-details/csrc-details.component";
import { TestCenterUserComponent } from "../manager/upload-test-center-user/test-center-user/test-center-user.component";
import { CandidateDetailsComponent } from "../manager/candidate-list/candidate-details/candidate-details.component";
import { UploadTestScheduleComponent } from "../manager/upload-test-schedule/upload-test-schedule.component";
import { TestScheduleComponent } from "../manager/upload-test-schedule/test-schedule/test-schedule.component";
import { CandidateScheduleComponent } from "../manager/upload-test-schedule/candidate-schedule/candidate-schedule.component";
import { UploadExamOSComponent } from "../manager/upload-exam-os/upload-exam-os.component";
import { QuestionBatchComponent } from './question-batch/question-batch.component';
import { MacAddressListComponent } from '../manager/mac-address-list/mac-address-list.component';
import { MacAddressDetailsComponent } from './mac-address-list/mac-address-details/mac-address-details.component';
import { UploadMacAddressComponent } from './mac-address-list/upload-mac-address/upload-mac-address.component';
import { TestBatchComponent } from './test-batch/test-batch.component';
import { JoblogComponent } from './jobs/joblog/joblog.component';
import { FtpDetailsComponent } from './ftp-details/ftp-details.component';
import { CandVerificationDataComponent } from "./candidate-list/candidate-details/cand-verification-data/cand-verification-data.component";
import { ExamDataCardComponent } from './candidate-list/candidate-details/exam-data-card/exam-data-card.component';


@NgModule({
  declarations: [
    DashboardComponent,
    UsersListComponent,
    CsrcDetailsComponent,
    UploadTestTimingComponent,
    TestCenterUserComponent,
    CandidateDetailsComponent,
    CandidateScheduleComponent,
    UsersComponent,
    CandidateListComponent,
    LanguageListComponent,
    PotralConfigurationComponent,
    PortalLanguageComponent,
    CandidateStatusComponent,
    PaymentStatusComponent,
    ListDataComponent,
    WidgetComponent,
    DefineQuestionTypeComponent,
    UploadExamCenterComponent,
    ConstantConfigurationComponent,
    UploadCSRCComponent,
    AppHeaderComponent,
    CSRCListComponent,
    CSRCListComponent,
    SectionStatusComponent,
    TopicStatusComponent,
    TestStatusComponent,
    JobsComponent,
    PushParentQuestionBankListComponent,
    PushParentQuestionBankComponent,
    UploadTestCenterUserComponent,
    UploadTestCenterUserListComponent,
    UploadTestScheduleComponent,
    TestScheduleComponent,
    UploadExamOSComponent,
    QuestionBatchComponent,
    MacAddressListComponent,
    MacAddressDetailsComponent,
    UploadMacAddressComponent,
    TestBatchComponent,
    JoblogComponent,
    FtpDetailsComponent,
    CandVerificationDataComponent,
    ExamDataCardComponent
  ],
  imports: [
    CommonModule,
    ManagerRouteModule,
    SharedModule,
    FormsModule,
    NgbModule,
    ReportsModule,
    BsDatepickerModule.forRoot()
  ]
})
export class ManagerModule {}
